export default "__VITE_ASSET__AMLkJeqE__"